import React, { Component } from 'react';

class Header extends Component {
	constructor(props) {
  		super(props);
  		this.state = {
  		};
    }

	render() {
    	return (
            <div className="row">
                <div className="col-12 text-center">
                    <h1>{this.props.text}</h1>
                </div>
            </div>
    	);
  	}
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/header.component.js